export type RadarLayerKey = 'rain' | 'snow' | 'ptype' | 'rain-extrap';

export interface RadarLayerConfig {
  key: RadarLayerKey;
  label: string;
  layer: string;
  style?: string;
  kind: 'observed' | 'forecast';
  legendLayer: string;
  legendStyle?: string;
}

export const GEOMET_WMS_URL = 'https://geo.weather.gc.ca/geomet';

export const RADAR_LAYERS: Record<RadarLayerKey, RadarLayerConfig> = {
  rain: {
    key: 'rain',
    label: 'Radar pluie',
    layer: 'RADAR_1KM_RRAI',
    style: 'RADARURPPRECIPR14-LINEAR',
    kind: 'observed',
    legendLayer: 'RADAR_1KM_RRAI',
    legendStyle: 'RADARURPPRECIPR14-LINEAR',
  },
  snow: {
    key: 'snow',
    label: 'Radar neige',
    layer: 'RADAR_1KM_RSNO',
    kind: 'observed',
    legendLayer: 'RADAR_1KM_RSNO',
  },
  ptype: {
    key: 'ptype',
    label: 'Type precipitation',
    layer: 'Radar_1km_SfcPrecipType',
    kind: 'observed',
    legendLayer: 'Radar_1km_SfcPrecipType',
  },
  'rain-extrap': {
    key: 'rain-extrap',
    label: 'Extrapolation pluie',
    layer: 'Radar_1km_RainPrecipRate-Extrapolation',
    style: 'RADARURPPRECIPR14-LINEAR',
    kind: 'forecast',
    legendLayer: 'Radar_1km_RainPrecipRate-Extrapolation',
    legendStyle: 'RADARURPPRECIPR14-LINEAR',
  },
};
